import React from 'react';
import { Banner, Button, Group } from '@qred/components-library';
import useTranslate from '~/hooks/useTranslate';

interface BankConnectionTroubleBannerProps {
  onAddManually: () => void;
  onClose: () => void;
}

const BankConnectionTroubleBanner = ({
  onAddManually,
  onClose,
}: BankConnectionTroubleBannerProps) => {
  const translate = useTranslate();

  return (
    <Banner
      opened
      state="warning"
      onClose={onClose}
      forceMobileView
      title={
        <span data-record>
          {translate('OnboardingOffer.BankConnectionTroubleTitle')}
        </span>
      }
      message={
        <span data-record>
          {translate('OnboardingOffer.BankConnectionTroubleDescription')}
        </span>
      }
    >
      <Group justify="flex-end">
        <Button
          variant="secondary"
          size="sm"
          rightIcon="east"
          onClick={onAddManually}
        >
          <span data-record>
            {translate('OnboardingOffer.AddManuallyButtonText')}
          </span>
        </Button>
      </Group>
    </Banner>
  );
};

export default BankConnectionTroubleBanner;
